import React from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonList,
  IonSearchbar,
  //IonLoading,
} from "@ionic/react";
import { useQuery } from "react-query";
import api from "@/services/api";
import { useI18n } from "@/i18n";

interface Team {
  id: number;
  name: string;
  short_name: string;
  league: string;
}

const Teams: React.FC = () => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const { t } = useI18n();

  const {
    data: teams,
    isLoading,
    error,
  } = useQuery<{ teams: Team[] }>(["teams"], async () => {
    const response = await api.get("/api/teams");
    return response.data;
  });

  const filteredTeams = teams?.teams?.filter(
    (team) =>
      team.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      team.short_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{t("teamsTitle")}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{t("teamsTitle")}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <div className="ion-padding">
          <IonSearchbar
            value={searchTerm}
            onIonInput={(e) => setSearchTerm(e.detail.value!)}
            placeholder={t("searchTeamsPlaceholder")}
          />

          {isLoading ? (
            <IonCard>
              <IonCardContent>
                <p>{t("loadingTeams")}</p>
              </IonCardContent>
            </IonCard>
          ) : error ? (
            <IonCard>
              <IonCardContent>
                <p>{t("errorTeams")}</p>
              </IonCardContent>
            </IonCard>
          ) : (
            <IonList>
              {filteredTeams?.map((team) => (
                <IonCard key={team.id}>
                  <IonCardHeader>
                    <IonCardTitle>{team.name}</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <IonItem>
                      <IonLabel>
                        <h2>{t("shortName")}</h2>
                        <p>{team.short_name}</p>
                      </IonLabel>
                    </IonItem>

                    <IonItem>
                      <IonLabel>
                        <h2>{t("leagueLabel")}</h2>
                        <p>{team.league}</p>
                      </IonLabel>
                    </IonItem>
                  </IonCardContent>
                </IonCard>
              ))}

              {filteredTeams?.length === 0 && (
                <IonCard>
                  <IonCardContent>
                    <p>{t("noTeams")}</p>
                  </IonCardContent>
                </IonCard>
              )}
            </IonList>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Teams;
